import { render } from "./Fight.vue?vue&type=template&id=373fb6b2&scoped=true"
import script from "./Fight.vue?vue&type=script&lang=js"
export * from "./Fight.vue?vue&type=script&lang=js"

import "./Fight.vue?vue&type=style&index=0&id=373fb6b2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373fb6b2"]])

export default __exports__